import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";

export default function LineasCobertura() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [bajando, setBajando] = useState(false);
  const [alto, setAlto] = useState(1600);
  useEffect(() => { api.get("/report/lineas-cobertura").then((r) => setD(r.data)).catch((e) => setErr(e?.response?.data?.detail || "No se pudo calcular la cobertura")); }, []);
  const pdf = async () => {
    setBajando(true);
    try {
      const r = await api.get("/report/lineas-cobertura.pdf", { responseType: "blob" });
      const url = URL.createObjectURL(r.data); const a = document.createElement("a");
      a.href = url; a.download = `Clientes_lineas_credito_${d.referencia.split("-").reverse().join("-")}.pdf`; a.click(); URL.revokeObjectURL(url);
    } catch { toast.error("No se pudo generar el PDF"); } finally { setBajando(false); }
  };
  return (
    <div data-testid="lineas-cobertura">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-2">
        <h2 className="text-lg font-bold" style={{ color: "#1F2A1D" }}>Líneas de crédito: cobertura</h2>
        {d && <button onClick={pdf} disabled={bajando} data-testid="lc-descargar-pdf" className="inline-flex items-center gap-2 rounded-full px-4 h-10 text-sm font-bold text-white" style={{ background: "#007336" }}>{bajando ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} Descargar PDF</button>}
      </div>
      {err && <p className="text-sm" style={{ color: "#B8402A" }} data-testid="lc-error">{err}</p>}
      {!d && !err && <p className="text-sm text-slate-500">Calculando…</p>}
      {d && <iframe title="Cobertura de líneas" srcDoc={d.html} data-testid="lc-contenido" className="w-full rounded-[20px] border-0" style={{ background: "#F7FAF6", height: alto }} onLoad={(e) => setAlto((e.target.contentDocument?.body?.scrollHeight || 2000) + 24)} />}
    </div>
  );
}
